export const LIST_EWSREPORT = 'src/Admin/Corporate/MeteringStats/LIST_EWSREPORT';
export const LIST_EWSREPORT_SUCCESS = 'src/components/Corporate/Create/action/LIST_EWSREPORT_Success';
export const LIST_EWSREPORT_FAILURE = 'src/components/Corporate/Create/action/LIST_EWSREPORT_Failure';

export const listEwsReport = (data) => {
    return {
        type: LIST_EWSREPORT,
        data
    }
}

export const listEwsReportSuccess = (data) => {
    return {
        type: LIST_EWSREPORT_SUCCESS,
        data
    }
}

export const listEwsReportFailure = (error) => {
    return {
        type: LIST_EWSREPORT_FAILURE,
        error
    }
}